<template>
    <comp-9-prep-adherence :section="9" :page="25" :nextDisabled="nextDisabled" :next="nextScreen">
        <p>
            Great! All these reasons and more! Now, how do these reasons translate to taking your PrEP every day? Being able to answer that question is super
            important because PrEP is most effective when it’s taken every day.
        </p>
        <p>
            Thinking about the last 30 days, how often did you take PrEP?
        </p>
        <v-radio-group v-model="prepAdherenceSelection" column>
            <v-radio v-for="adherence in prepAdherences" :key="adherence.id" :label="adherence.text" :value="adherence"></v-radio>
        </v-radio-group>
    </comp-9-prep-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { find, forEach } from 'lodash';

export default {
    data: function() {
        return {
            prepAdherenceSelection: null
        };
    },
    computed: {
        prepAdherence() {
            let selectedPrepAdherence = find(this.prepAdherences, 'selected');

            if (selectedPrepAdherence) {
                return selectedPrepAdherence;
            } else return null;
        },
        prepAdherences: sync('section9/prepAdherence'),
        nextScreen() {
            if (this.prepAdherenceSelection) {
                return `/page/9/${this.prepAdherenceSelection.nextScreen}`;
            }

            return null;
        }
    },
    methods: {
        nextDisabled() {
            return !this.prepAdherenceSelection;
        }
    },
    watch: {
        prepAdherenceSelection(newPrepAdherenceSelection) {
            forEach(this.prepAdherences, o => {
                if (o.id === newPrepAdherenceSelection.id) {
                    o.selected = true;
                } else {
                    o.selected = false;
                }
            });
        }
    },
    mounted() {
        this.prepAdherenceSelection = this.prepAdherence;
    }
};
</script>
